export default "__VITE_ASSET__DjGAUQVO__"